import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { Dimensions, Platform, SafeAreaView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Button, Icon } from '../components';
import { APP_STORE_LINK, PLAY_STORE_LINK } from '../config';
import Theme from '../theme';
import { ChevronRightIcon, FitbeatIcon } from '../ui';
import { getOSOnWeb, WebOS } from '../utils';
import { Logger } from '../utils/Logger';
import { InstallAppButton } from './components';
import { styles as SharedStyles } from './SignupFormsStyles';
import { openLink } from '../utils/linkUtils';

const { width } = Dimensions.get('window');
const isMobileWeb = width <= 550 && Platform.OS === 'web';

interface IProps {
  t: (key: string) => string;
  navigation: any
}

class OnBoardingComplete extends PureComponent<IProps, {}> {


  public isWebOnMobileDevice = (): boolean => {
    const webOs = getOSOnWeb();
    return isMobileWeb &&
      (webOs === WebOS.Android || webOs === WebOS.iOS);
  }

  public openAndroid = () => {
    openLink(PLAY_STORE_LINK)
      .catch((e) => Logger.notify(e));
  }

  public openIos = () => {
    openLink(APP_STORE_LINK)
      .catch((e) => Logger.notify(e));
  }

  public goToDashboard = () => {
    this.props.navigation.navigate('HomeLoading');
  }

  public render() {
    const { t } = this.props;
    const containerStyle = this.isWebOnMobileDevice() ? { height: '100%', justifyContent: 'space-between' } : {};
    return (
      <>
        {this.isWebOnMobileDevice() &&
          <TouchableOpacity
            style={styles.closeButton}
            hitSlop={{ bottom: 20, top: 20, left: 20, right: 20 }}
            onPress={this.goToDashboard}>
            <Icon
              name="md-close"
              color={Theme.GREY}
              size={40}
            />
          </TouchableOpacity>
        }
        <SafeAreaView style={[SharedStyles.container, containerStyle]}>


          <View style={styles.headerContainer}>
            <View style={{marginTop: 30}}><FitbeatIcon width={80} height={80} /></View>

            <Text style={styles.header}>{t('getReadyForPersonalised').toUpperCase()}</Text>

            <View style={styles.setupContainer}>
              <View style={styles.descriptionContainer}>
                <ChevronRightIcon width={18} height={18} color={Theme.PRIMARY} />
                <Text style={styles.setupText}>{t('workouts')}</Text>
              </View>
              <View style={styles.descriptionContainer}>
                <ChevronRightIcon width={18} height={18} color={Theme.PRIMARY} />
                <Text style={styles.setupText}>{t('nutrition')}</Text>
              </View>
              <View style={styles.descriptionContainer}>
                <ChevronRightIcon width={18} height={18} color={Theme.PRIMARY} />
                <Text style={styles.setupText}>{t('tracking')}</Text>
              </View>
            </View>
            </View>

          {this.isWebOnMobileDevice()
            ?
            <View style={styles.appInstallContainer}>
              <View>
                <Text style={styles.installText}>{t('installAppForHomeWorkouts')}</Text>
                <InstallAppButton t={t}/>
              </View>
            </View>
            :
            <Button
              title={t('continue')}
              fontColor={Theme.WHITE}
              containerStyle={{ margin: 20 }}
              onPress={this.goToDashboard}
            />
          }
        </SafeAreaView>
      </>
    );
  }
}

const styles = StyleSheet.create({
  headerContainer: {
    flex: 1,
    alignItems: 'center',
    padding: 20,
    paddingTop: 30
  },
  header: {
    textAlign: 'center',
    fontSize: 35,
    fontFamily: Theme.Custom700,
    paddingVertical: 20,
    color: Theme.CHARCOAL,
  },
  setupContainer: {
    alignSelf: 'center',
    marginTop: 20
  },
  appInstallContainer: {
    backgroundColor: Theme.GREY_LIGHT,
  },
  descriptionContainer: {
    flexDirection: 'row',
    paddingVertical: 5,
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
  },
  setupText: {
    fontSize: 20,
    lineHeight: 20,
    marginLeft: 15,
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom500,
  },
  installText: {
    fontSize: 25,
    paddingVertical: 20,
    textAlign: 'center',
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom800,
  },
  closeButton: {
    top: 5,
    right: 15,
    position: 'absolute',
    zIndex: 10,
  }
})

export const OnBoardingCompleteScreen = translate('auth', { wait: true })(OnBoardingComplete);
